import { ISizes } from '@webtrader/core/themes/sizes';

import { DARK_THEME_COLORS, IColors, LIGHT_THEME_COLORS } from './colors';
import { IMobileThemeColors } from './platforms/mobile';
import { IWebThemeColors } from './platforms/web';

export enum EAppTheme {
  DARK = 'DARK',
  LIGHT = 'LIGHT'
}

export enum EThemeScheme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
  SYSTEM = 'SYSTEM'
}

export enum EThemeTemplate {
  HANTEC = 'HANTEC',
  DEFAULT = 'DEFAULT'
}

export interface IFonts {
  DEFAULT_FONT_FAMILY: string;
  DEFAULT_ANDROID_FONT_FAMILY: string;
  DEFAULT_ANDROID_FONT_FAMILY_ITALIC: string;
  DEFAULT_ANDROID_FONT_FAMILY_MEDIUM: string;
  DEFAULT_ANDROID_FONT_FAMILY_MEDIUM_ITALIC: string;
}

export interface IAppTheme {
  sizes: ISizes;
  colors: IColors;
  scheme: EThemeScheme;
  font: IFonts;
}

export interface IAppThemeColors {
  web?: IWebThemeColors;
  mobile?: IMobileThemeColors;
}

export const rgba = (rgb: string | undefined, opacity: number) => {
  if (!rgb) {
    return '';
  }

  return rgb.replace('rgb', 'rgba').replace(')', `, ${opacity})`);
};

export const hexToRgb = (hex: string, opacity?: number) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (result) {
    const r = parseInt(result[1], 16);
    const g = parseInt(result[2], 16);
    const b = parseInt(result[3], 16);

    if (opacity !== undefined) {
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    return `rgb(${r}, ${g}, ${b})`;
  }

  return null;
};

export const schemeToColors = (scheme: EThemeScheme) => {
  switch (scheme) {
    case EThemeScheme.DARK:
      return DARK_THEME_COLORS;
    case EThemeScheme.LIGHT:
      return LIGHT_THEME_COLORS;
    default:
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return DARK_THEME_COLORS;
      }

      return LIGHT_THEME_COLORS;
  }
};
